const topics = {};

$.Topic = function (id) {
    let callbacks,
        topic = id && topics[id];

    if (!topic) {
        // Ensures the callback list can only be fired once (like a Deferred).
        // Keeps track of previous values and will call any callback added after the list has been fired right away with the latest "memorized" values (like a Deferred).
        // Ensures a callback can only be added once (so there are no duplicates in the list).
        callbacks = $.Callbacks("once memory unique");
        topic = {
            publish: callbacks.fire,
            subscribe: callbacks.add,
            unsubscribe: callbacks.remove,
            has: callbacks.has,
        };

        if (id) {
            topics[id] = topic;
        }
    }

    return topic;
};

export function addOnReady(fnc) {
    $.Topic('onReady').subscribe(fnc);
}

/**
 * Should only be called after the page is fully loaded
 */
export function triggerOnReady() {
    $.Topic('onReady').publish();
}


